export default __webpack_public_path__ + "static/media/Vector (1).9fa5b82f.svg";